export default [
  { title: 'Bietingen', value: '133219205FE', address: 'Dr. Hager Bietingen\nStockenweg 1\n78244 Gottmadingen' },
  { title: 'Konstanz', value: '1618A1251CA', address: 'Dr. Hager Konstanz\nObere Laube 48\n78462 Konstanz' },
]
